<div class="container-1">
  <div class="container-fluid mt-3">
    <div class="row">
      <div class="col-md-6">
        <div>
          <label class="label-header">Contact Details</label>
          <hr class="contact-h-line" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="pull-right pull-right-date">
          <label class="day-count">
            Last {{bindNumberOfDays}} days
          </label>
          <hr class="contact-h-line" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ">
        <div class="tbl-scroll">
          <table class="table">
            <tbody>
              <tr>
                <th class="" style="padding-left: 14px !important;">
                  <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg"
                    style="margin-right:3px">
                    <path d="M5 8L0.669872 0.500001L9.33013 0.5L5 8Z" fill="#C4C4C4" />
                  </svg>
                  Contact
                </th>
                @for (ContactDetail of contactDetails; track ContactDetail) {
                  <th class="">
                    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg"
                      style="margin-right:3px">
                      <path d="M5 8L0.669872 0.500001L9.33013 0.5L5 8Z" fill="#C4C4C4" />
                    </svg>
                    {{ContactDetail}}
                  </th>
                }
              </tr>
              @for (ContactDetailList of contactDetailsList; track ContactDetailList; let i = $index) {
                <tr class="details-contact"
                  id="rowId{{i}}">
                  <td style="border-right:0;padding-left: 16px !important;">
                    <label class="contact-details-list font-weight-bold"
                    [ngClass]="{'set-color-condition':ContactDetailList.requestedType=='Text'}">{{ContactDetailList.requesterName}}</label>
                  </td>
                  <td class="hide-med-border">
                    <label class="contact-details-list">{{ContactDetailList.teamName}}</label>
                  </td>
                  <td class="hide-med-border">
                    @if (ContactDetailList.requestedType=='LiveChat') {
                      <label class="contact-details-list"
                      [ngClass]="{'set-color-condition':ContactDetailList.requestedStatus=='LiveChat'}">{{ContactDetailList.requestedStatus}}</label>
                    }
                  </td>
                  <td class="hide-med-border">
                    <label class="contact-details-list ml-4 font-weight-bold"
                    [ngClass]="{'set-color-condition':ContactDetailList.requestedType=='Text'}">{{ContactDetailList.requestedType}}</label>
                  </td>
                  <td class="hide-med-border">
                    <label class="contact-details-list ">{{ContactDetailList.phoneNumber}}</label>
                  </td>
                  <td class="hide-med-border">
                    <label class="question-elipses" id="displayless{{i}}">Q: {{ContactDetailList.question}}</label>
                    @if (ContactDetailList.question!=null) {
                      <label class="show-more"
                      (click)="showMore('labeltxt'+ i,'displayless' + i)" id="labeltxt{{i}}">more</label>
                    }
                  </td>
                  <td class="hide-med-border" width="215px">
                    <label class="contact-details-list">{{ContactDetailList.requestDateTime |date: 'MM/dd/yyyy'}}</label>
                    <label class="contact-details-list ml-2 time">{{ContactDetailList.requestDateTime |date:' h:mm a'|
                    lowercase}}</label>
                  </td>
                  <td style="border-left:0;" #filterIcon width="100px">
                    <button class="view-transcript"
                    (click)="viewTranscript(ContactDetailList.helpSessionId,'rowId' + i)">View transcript</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-md-12  mb-3 ">
      <button class="close-details pull-right" (click)="confirmDone()">Done</button>
    </div>
  </div>
</div>